import React from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import ProjectForm from '../ProjectForm';
import JumperScrollbar from '../../JumperScrollbar/JumperScrollbar';

const ProjectNew = (props) => {
  const onSubmit = (data) => {
    props.onSubmit(data);
    props.history.goBack();
  };
  return (
    <JumperScrollbar
      style={{ display: 'block' }}
      thumbStyle={{
        backgroundColor: 'rgb(145,153,154)',
        width: '10px',
        cursor: 'pointer',
      }}
    >
      <ProjectForm {...props} onSubmit={onSubmit} />
    </JumperScrollbar>
  );
};

ProjectNew.propTypes = {
  history: PropTypes.shape({
    goBack: PropTypes.func.isRequired,
  }).isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default Radium(ProjectNew);



// WEBPACK FOOTER //
// ./src/components/Project/ProjectNew/ProjectNew.js